module.exports = __webpack_public_path__ + "img/black-women-casual-daylight-eyeglasses-1.e7a2db91.webp";